import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "row",
    aligItems: "center",
    alignContent: "center",
    background: "#FBFBFC",
    color: "#000000",
    boxShadow: "none",
    height: 72,
    width: "100%",
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(16),
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  toolbar: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
    flexBasis: "100%",
  },
  right: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "end",
    flex: 1,
    alignItems: "center",
  },
  logo: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  hide: {
    display: "none!important",
  },
  arrowLeft: {
    display: "flex",
    cursor: "pointer",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  actions: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    alignContent: "center",
    columnGap: "1rem",
    "& svg": {
      marginLeft: "0.25rem",
      marginRight: 0,
      cursor: "pointer",
    },
  },
  responsiveMenu: {
    order: 3,
    width: "41px",
    height: "40px",
    padding: "8px 6px 8px 6px",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "#E6F1FF;",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  menuIconActive: {
    backgroundColor: "#E6F1FF;",
  },
  userDropdown: {
    whiteSpace: "nowrap",
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    [theme.breakpoints.down(768)]: {
      display: "none",
    },
  },
  avatar: {
    width: 50,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#E8EAEF",
    [theme.breakpoints.down(768)]: {
      display: "none",
    },
    "& svg": {
      marginInlineEnd: 0,
      marginLeft: 0,
    },
  },
}));
